module.exports = __webpack_public_path__ + "static/media/loader.4dcf01bc.svg";